import { render, staticRenderFns } from "./TreatmentReservationCompletePage.vue?vue&type=template&id=b29e5a92&scoped=true&"
import script from "./TreatmentReservationCompletePage.vue?vue&type=script&lang=ts&"
export * from "./TreatmentReservationCompletePage.vue?vue&type=script&lang=ts&"
import style0 from "./TreatmentReservationCompletePage.vue?vue&type=style&index=0&id=b29e5a92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b29e5a92",
  null
  
)

export default component.exports